export default {
  CAR_ACCIDENT: "carAccident",
  OTHER_ACCIDENT: "otherAccident",
  SICK: "sick",
  OTHER: "other",
}
